import { render } from "./PortMessage.vue?vue&type=template&id=3815afd1"
import script from "./PortMessage.vue?vue&type=script&lang=js"
export * from "./PortMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__